type MenuDataItem = {
  path?: string;
  name?: string;
  locale?: string | false;
  key?: string;
  children?: MenuDataItem[];
  hideInMenu?: boolean;
  [key: string]: unknown;
};

const LEARN_ROOT_PATH = '/learn';
const MANAGE_ROOT_PATH = '/manage';

const getPortalRootPath = (pathname: string): string | null => {
  if (pathname.startsWith(LEARN_ROOT_PATH)) {
    return LEARN_ROOT_PATH;
  }

  if (pathname.startsWith(MANAGE_ROOT_PATH)) {
    return MANAGE_ROOT_PATH;
  }

  return null;
};

const filterHiddenMenuItems = (menuItems: MenuDataItem[] = []): MenuDataItem[] => {
  return menuItems
    .filter((item) => !item.hideInMenu)
    .map((item) => {
      if (!item.children?.length) {
        return item;
      }

      return {
        ...item,
        children: filterHiddenMenuItems(item.children),
      };
    });
};

export const getPortalMenuData = (
  menuData: MenuDataItem[] = [],
  pathname: string,
): MenuDataItem[] => {
  const portalRootPath = getPortalRootPath(pathname);

  if (!portalRootPath) {
    return menuData;
  }

  const portalMenuGroup = menuData.find((item) => item.path === portalRootPath);

  if (!portalMenuGroup?.children?.length) {
    return [];
  }

  return filterHiddenMenuItems(portalMenuGroup.children);
};

export { getPortalRootPath };
export type { MenuDataItem };
